import styled from 'styled-components';

import { colors } from '../../../../theme';
import PopoverContent from '../../../Popover/PopoverContent';

export const OptionsPopoverContent = styled(PopoverContent)`
  padding: 0;
  background-color: ${colors.pearl};
  border: 1px solid ${colors.concrete};
  box-shadow: none;
  overflow: hidden;
`;
